import { DatasheetForm } from "./DatasheetForm";

export function NewDatasheetPage() {
  return <DatasheetForm />;
}
